import styled, { keyframes, css } from "styled-components";

const slideIn = keyframes`
  from {
    transform: translateY(100%);
  }
  to {
    transform: translateY(0%);
  }
`;

const slideOut = keyframes`
  from {
    transform: translateY(0%);
  }
  to {
    transform: translateY(100%);
  }
`;

export const ModelWindowStyles = styled.div`
  background: #d9d9d9b3;
  overflow-y: scroll;
  position: fixed;
  top: 0;
  right: 0;
  width: 100%;
  height: 100%;
  z-index: 5;

  animation: ${(props) =>
    props.$isClosing
      ? css`
          ${slideOut} 250ms cubic-bezier(0.61, 0, 0.51, 1)
        `
      : css`
          ${slideIn} 250ms cubic-bezier(0.61, 0, 0.51, 1)
        `};
`;
